import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../App.css";
import logo from "../img/logo.png";
import portadaImage from "../img/portada.jpg";

const Login = () => {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState("");
  const [contraseña, setContraseña] = useState("");
  const [mostrarContraseña, setMostrarContraseña] = useState(false);
  // Modal recuperación
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);
  const [correoReset, setCorreoReset] = useState("");
  const [token, setToken] = useState("");
  const [nuevaContraseña, setNuevaContraseña] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showNuevaContraseña, setShowNuevaContraseña] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!correo || !contraseña) {
      toast.error("Por favor, completa los campos: Correo y Contraseña.");
      return;
    }

    const loadingToastId = toast.loading("Iniciando sesión...");

    try {
      localStorage.clear();
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/token?correo=${encodeURIComponent(
          correo.toLowerCase()
        )}&password=${encodeURIComponent(contraseña)}`
      );

      const { access_token, rol, rol2, nombre_get, numero_grupo, estado } =
        response.data;

      localStorage.setItem("access_token", access_token);
      localStorage.setItem("nombre_get", nombre_get || "");
      localStorage.setItem("rol", rol || "");
      localStorage.setItem("rol2", rol2 || "");
      localStorage.setItem("grupo", numero_grupo || "");
      localStorage.setItem("estado", estado || "");

      toast.dismiss(loadingToastId);
      toast.success("Inicio de sesión exitoso");

      if (rol === "Solicitante GET" && rol2 === "Senior GET") {
        navigate("/rol2");
      } else if ((rol === "Lider" || rol === "Subrogante") && rol2 === "Staff") {
        navigate("/rol");
      } else if (rol === "Senior GET" && rol2 === "Staff") {
        navigate("/rol3");
      } else {
        switch (rol) {
          case "Solicitante GET":
            navigate("/menusolicitante");
            break;
          case "Staff":
            navigate("/menustaff");
            break;
          case "Lider":
          case "Subrogante":
            navigate("/menulider");
            break;
          case "Senior GET":
            navigate("/MenuSeniorGET");
            break;
          case "Socio GET":
            navigate("/menusocio_get");
            break;
          case "Admin":
            navigate("/MenuAdmin");
            break;
          default:
            toast.error("Rol no reconocido");
        }
      }
    } catch (error) {
      toast.dismiss(loadingToastId);
      toast.error(
        error.response?.data?.name || "Error al iniciar sesión. Verifica tus credenciales."
      );
      console.error("Error al iniciar sesión:", error);
    }
  };

  const handleEnviarCorreo = async () => {
    if (!correoReset.includes("@")) {
      toast.error("Por favor, ingresa un correo válido");
      return;
    }
    setIsLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/forgot-password`, {
        correo: correoReset.toLowerCase(),
      });
      toast.success("Correo enviado con éxito. Revisa tu bandeja.");
      setStep(2);
    } catch (error) {
      toast.error("Error al enviar el correo");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (nuevaContraseña.length < 8) {
      toast.error("La nueva contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (!token) {
      toast.error("Por favor, ingresa el código");
      return;
    }
    setIsLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`, {
        correo: correoReset.toLowerCase(),
        token,
        nueva_contraseña: nuevaContraseña,
      });
      toast.success("Contraseña actualizada correctamente");
      setShowModal(false);
      setStep(1);
      setCorreoReset("");
      setToken("");
      setNuevaContraseña("");
    } catch (error) {
      toast.error("Código inválido o expirado");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login2-container">
      <style>
        {`
          /* Estilo para el efecto hover en ¿Olvidaste tu contraseña? */
          .forgot-password:hover {
            color: purple;
            transition: color 0.3s ease;
          }

          /* Contenedor para los puntitos de carga */
          .loading-dots {
            display: inline-flex;
            align-items: center;
          }

          /* Animación de los puntitos */
          .dot {
            animation: dot-bounce 1.4s infinite ease-in-out both;
            margin-left: 2px;
          }

          .dot:nth-child(1) { animation-delay: -0.32s; }
          .dot:nth-child(2) { animation-delay: -0.16s; }

          @keyframes dot-bounce {
            0%, 80%, 100% { transform: scale(0); }
            40% { transform: scale(1); }
          }
        `}
      </style>

      <div className="login-content">
        <div className="login-card">
          <img src={logo} alt="Grant Thornton Logo" className="login-logo" />
          <h1>¡Bienvenido Nuevamente!</h1>
          <form onSubmit={handleLogin}>
            <div className="form-group-unique">
              <label htmlFor="correo" className="label-unique">Correo:</label>
              <input
                type="email"
                id="correo"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="Ingresa tu correo"
                required
                className="input-unique"
              />
            </div>
            <div className="form-group-unique">
              <label htmlFor="contraseña" className="label-unique">Contraseña:</label>
              <div className="input-container-unique">
                <input
                  type={mostrarContraseña ? "text" : "password"}
                  id="contraseña"
                  value={contraseña}
                  onChange={(e) => setContraseña(e.target.value)}
                  placeholder="Ingresa tu contraseña"
                  required
                  className="input-unique"
                />
                <span
                  className="icon-container-unique"
                  onClick={() => setMostrarContraseña(!mostrarContraseña)}
                >
                  {mostrarContraseña ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <p
                className="forgot-password"
                onClick={() => setShowModal(true)}
                style={{ cursor: "pointer", marginTop: "10px" }}
              >
                ¿Olvidaste tu contraseña?
              </p>
            </div>
            <button type="submit" className="button-unique">Iniciar Sesión</button>
          </form>
          <Toaster />
        </div>
      </div>
      <div className="login-image" style={{ backgroundImage: `url(${portadaImage})` }}></div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Recuperar contraseña</h2>
            {step === 1 ? (
              <>
                <p>Ingresa tu correo organizacional</p>
                <input
                  type="email"
                  value={correoReset}
                  onChange={(e) => setCorreoReset(e.target.value)}
                  className="input-unique"
                  placeholder="Correo organizacional"
                />
                <button
                  onClick={handleEnviarCorreo}
                  className="button-unique lasers"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="loading-dots">
                      Enviando<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span>
                    </span>
                  ) : (
                    "Enviar correo"
                  )}
                </button>
              </>
            ) : (
              <>
                <p>Ingresa el código que recibiste y tu nueva contraseña</p>
                <input
                  type="text"
                  placeholder="Código"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  className="input-unique"
                />
                <div className="input-container-unique">
                  <input
                    type={showNuevaContraseña ? "text" : "password"}
                    placeholder="Nueva contraseña"
                    value={nuevaContraseña}
                    onChange={(e) => setNuevaContraseña(e.target.value)}
                    className="input-unique"
                  />
                  <span
                    className="icon-container-unique"
                    onClick={() => setShowNuevaContraseña(!showNuevaContraseña)}
                  >
                    {showNuevaContraseña ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <button
                  onClick={handleResetPassword}
                  className="button-unique lasers"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="loading-dots">
                      Actualizando<span className="dot">.</span><span className="dot">.</span><span className="dot">.</span>
                    </span>
                  ) : (
                    "Actualizar contraseña"
                  )}
                </button>
              </>
            )}
            <button
              onClick={() => setShowModal(false)}
              className="button-unique"
              style={{ marginTop: "10px", background: "red", color: "white" }}
              disabled={isLoading}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;